module.exports = __webpack_public_path__ + "static/img/qiangguangshoudian.d119ba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qiangguangshoudian.png
// module id = YwhK
// module chunks = 21